<h1>Events</h1>
<p><small>Order is from left to right. Drag events to reorder them.</small></p>

<div class="row-cols-1 row-cols-md-2 g-4 mt-1">
  <app-drag-drop-multi-direction
    [items]="events"
    (arrayChanged)="updateEventOrder($event)"
    (editIconClick)="edit($event)"
    (deleteIconClick)="confirmDelete($event)"
    [configuration]="configuration"
  >
  </app-drag-drop-multi-direction>
</div>

<div class="center mt-5 pb-5" id="editSection">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="addEventItem()"
    [attr.aria-expanded]="isCollapsed"
    aria-controls="collapseExample"
    aria-label="add"
  >
    <fa-icon [icon]="faPlusSquare"></fa-icon>
  </button>
</div>

<div #collapse="ngbCollapse" [ngbCollapse]="!isCollapsed" (ngbCollapseChange)="isCollapsed = $event">
  <app-events-form
    [eventData]="eventData"
    (refreshData)="getEventItem()"
  ></app-events-form>
</div>